module.exports = __webpack_public_path__ + "img/premiere-after-min.e0217e47.webp";